import React from 'react';
import { Modal } from '@cimpress/react-components';
import { css } from 'react-emotion';
import { actions as termActions } from '../../../reducers/terms';
import { connect } from 'react-redux';
import useForm from 'react-hook-form';
import { useAsyncCallback } from 'react-async-hook';
import ErrorText from '../createContract/buyerFlow/Shared/ErrorText';
import { useTranslation } from 'react-i18next';

const buttonStyle = css`
  margin-top: 10px;
  margin-left: 10px;
  float: right;
`;

export function EditNameModal({ setLatestRevision, onCloseModal, modalOpened, updateTermName, termRevision }) {
  const onSubmit = data => updateTermName(data.name).then(({ payload }) => setLatestRevision(payload));

  const { t } = useTranslation();

  const { register, handleSubmit, errors: formErrors } = useForm({
    defaultValues: { name: termRevision.additionalData.name }
  });
  const { execute, loading, error: submitError } = useAsyncCallback(onSubmit);

  return (
    <Modal
      show={modalOpened}
      onRequestHide={onCloseModal}
      title={t('contractActions:editNameModal.title')}
      closeButton
      closeOnOutsideClick>
      <form onSubmit={handleSubmit(execute)}>
        <div className="form-group required">
          <input
            required
            className="form-control"
            name="name"
            type="text"
            ref={register({
              validate: {
                unique: value =>
                  value !== termRevision.additionalData.name || t('contractActions:validateUniqueMessage'),
                required: value => !!value.trim() || t('contractActions:requiredMessage')
              }
            })}
          />
          {formErrors.name && <ErrorText text={formErrors.name.message} />}
        </div>

        <button className={`btn btn-primary ${buttonStyle}`} type="submit" disabled={loading}>
          {t('contractActions:saveAndUpdate')}
        </button>
        <button className={`btn btn-default ${buttonStyle}`} type="button" disabled={loading} onClick={onCloseModal}>
          {t('common:commonWords.cancel')}
        </button>
        {submitError && (
          <ErrorText text={submitError.payload ? submitError.payload.message : JSON.stringify(submitError)} />
        )}
      </form>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { termRevision } = ownProps;
  return {
    updateTermName: name => dispatch(termActions.updateTermName(termRevision.termId, termRevision.revisionId, name))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(EditNameModal);
